import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import locales from "../locales.json";

const About = () => {
  const { lang } = useLang();
  const { about_page } = locales;

  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: { xs: "32px", md: "50px" }, // Moins de padding sur mobile
        textAlign: "center",
        maxWidth: { xs: "100%", md: "900px" }, // 100% sur mobile, 900px sur desktop
        width: "100%",
        px: { xs: 2, md: 0 }, // Padding horizontal sur mobile
        boxSizing: "border-box",
      }}
    >
      <Typography
        variant="h2"
        sx={{
          fontWeight: "bold",
          marginBottom: "20px",
          fontSize: { xs: "2rem", md: "2.5rem" }, // Taille adaptée
          wordBreak: "break-word",
        }}
      >
        {about_page.title[lang]}
      </Typography>

      <Typography
        variant="h6"
        sx={{
          marginBottom: "30px",
          maxWidth: "800px",
          fontSize: { xs: "1.1rem", md: "1.25rem" },
          mx: "auto",
          wordBreak: "break-word",
        }}
      >
        {about_page.paragraph1[lang]}
      </Typography>

      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          maxWidth: "800px",
          fontSize: { xs: "1rem", md: "1.1rem" },
          mx: "auto",
          wordBreak: "break-word",
        }}
      >
        {about_page.paragraph2[lang]}
      </Typography>

      <Box sx={{ marginBottom: "50px" }}>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/license"
          sx={{
            borderRadius: "50px",
            px: 4,
            py: 1.5,
            fontWeight: "bold",
            fontSize: { xs: "1rem", md: "1.1rem" },
            backgroundColor: (theme) => theme.palette.secondary.light,
            "&:hover": {
              backgroundColor: (theme) => theme.palette.secondary.main,
            },
          }}
        >
          {about_page.cta_button[lang]}
        </Button>
      </Box>
    </Container>
  );
};

export default About;
